import { createOutlineIcon } from "../createIcon";

export const XOutlineIcon = createOutlineIcon(
  <path d="M18 6 6 18m12 0L6 6" />,
  "XOutlineIcon"
);
